<template>
  <div class="buttonStyle" :style="{ '--theme-color': themeColor, height: btnHeight }" @click="handleCommand">
    <div :class="`btn-${info.info.buttonStyle}`" :style="[btnBg, getRadius]">
      <template v-if="info.info.buttonStyle === 'two'">
        <template v-if="isObject(info.info.icon)">
          <iconModule v-if="isObject(info.info.icon)" :config="info.info.icon" class="icon-img" :style="imgStyle">
          </iconModule>
        </template>
        <template v-else>
          <template v-if="info.info.icon === 1 && info.info.buttonStyle === 'two'">
            <i v-if="info.info.buttonStyle === 'two'" :style="{ color: isTable ? '#333' : '' }"
              :class="`iconfont ${handleDiffTodo('icon')}`"></i>
          </template>
          <template v-else-if="info.info.buttonStyle === 'two'">
            <img :src="$imgurl + info.info.icon" class="icon-img" :style="imgStyle" />
          </template>
        </template>
      </template>
      <span v-if="info.info.buttonStyle !== 'three'" @click.prevent :class="`btn-${info.info.buttonStyle}-text`"
        :style="[getFontStyle, { color: isTable && info.info.buttonStyle !== 'one' ? '#333' : '' }]"
        style="white-space: nowrap;">
        {{ info.info.text || handleDiffTodo("text") }}
      </span>
      <el-tooltip v-if="info.info.buttonStyle === 'three'" :content="info.info.text || handleDiffTodo('text')"
        popper-class="btn-tips" placement="bottom">
        <template v-if="isObject(info.info.icon)">
          <iconModule v-if="isObject(info.info.icon)" :config="info.info.icon" class="icon-img" :style="imgStyle">
          </iconModule>
        </template>
        <template v-else>
          <template v-if="info.info.icon === 1">
            <i :style="{ fontSize: size, color: isTable ? '#333' : '' }"
              :class="`iconfont ${handleDiffTodo('icon')}`"></i>
          </template>
          <template v-else-if="info.info.buttonStyle === 'three'">
            <img :src="$imgurl + info.info.icon" class="icon-img" :style="imgStyle" />
          </template>
        </template>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import iconMixin from '@/components/common/icon/common.js'

export default {
  // 组件名称
  name: 'btnContainer',
  // 组件参数 接收来自父组件的数据
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    themeColor: {
      type: String,
      default: '#4e86ff'
    },
    // 默认不需要
    size: {
      type: String,
      default: '14px'
    },
    // 默认不需要
    isTable: {
      type: Boolean,
      default: false
    },
    fontStyle: {
      type: Object,
      default: () => ({})
    },
    btnHeight: {
      type: String,
      default: '100%'
    }
  },
  mixins: [iconMixin],
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {}
  },
  // 计算属性
  computed: {
    btnBg() {
      let bg = {}
      if (this.info.info.buttonBackground) {
        const buttonBackground = this.info.info.buttonBackground
        if (buttonBackground.type === 0) {
          bg = {
            background: buttonBackground.color
          }
        } else {
          bg.background = `url(${this.$imgurl}${buttonBackground.image}) no-repeat`
          bg.backgroundSize = '100% 100%'
        }
      }
      return bg
    },
    imgStyle() {
      if (this.fontStyle && (parseInt(this.fontStyle.fontSize) <= 12)) {
        return {
          width: '16px',
          height: '16px'
        }
      } else {
        return {}
      }
    },
    getFontStyle() {
      // 颜色等于#ccc就是默认值不用修改
      const fontStyle = JSON.parse(JSON.stringify(this.info.fontStyle || this.fontStyle))
      if (fontStyle && fontStyle.color === '#ccc') {
        fontStyle.color = '#333'
      }
      return fontStyle
    },
    getRadius() {
      const obj = {
        rightAngle: '0',
        fillet: '4px',
        fullRoundedCorner: '100%'
      }
      return {
        borderRadius: obj[this.info.info.buttonRadius] || '4px'
      }
    },
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    handleCommand(e) {
      switch (this.info.info.bindingFunction) {
        case 'list-todo':
          // 阻止冒泡
          e.stopPropagation()
          this.$emit('todo-list')
          return
        default:
          this.$emit('btnClick', this.info.info.bindingFunction)
          return
      }
    },
    // 处理图标转化
    handleDiffTodo(type) {
      // 判断是否处理图标和文本
      const flag = type === 'icon'
      switch (this.info.info.bindingFunction) {
        // 填写表单
        case 'write-table':
          return flag ? 'icon-a-tianxieziliao2x' : '新增'
        case 'all-write-table':
          return flag ? 'icon-a-tianxieziliao2x' : '批量新增'
        // 字段显示设置
        case 'filed-show':
          return flag ? 'icon-a-ziduan2x' : '显示'
        // 批量操作
        case 'all-action':
          return flag ? 'icon-a-piliangbianji2x' : '批量操作'
        // 批量导入
        case 'all-in':
          return flag ? 'icon-a-daoru2x' : '导入'
        case 'all-in-all':
          return flag ? 'icon-a-daoru2x' : '全部数据导入'
        case 'all-in-person':
          return flag ? 'icon-a-daoru2x' : '个人数据导入'
        // 批量审批
        case 'all-approve':
          return flag ? 'icon-shenhe' : '批量审批'
        // 批量删除
        case 'all-del':
          return flag ? 'icon-a-shanchu2x' : '删除'
        // 批量修改
        case 'all-edit':
          return flag ? 'icon-a-piliangbianji2x' : '批量修改'
        // 批量导出报表
        case 'all-out-table':
          return flag ? 'icon-daochubaobiao' : '导出'
        // 批量导出附件
        case 'all-out-annex':
          return flag ? 'icon-a-daochufujian2x' : '下载附件'
        // 上传区块链
        case 'all-upload':
          return flag ? 'icon-a-daochufujian2x' : '上传区块链'
        // 数据筛选
        case 'data-screen':
          return flag ? 'icon-a-shaixuan2x' : '筛选'
        // 应用任务
        case 'apply-action':
          return flag ? 'icon-a-biaodanguanli2x' : '应用任务'
        // 全部标记已读
        case 'all-already':
          return flag ? 'icon-a-shaixuan2x' : '全部标记已读'
        // 未读筛选
        case 'unread':
          return flag ? 'icon-a-shaixuan2x' : '未读筛选'
        // 已读
        case 'already-read':
          return flag ? 'icon-a-shaixuan2x' : '已读筛选'
        // 站内应用
        case 'inside':
          return flag ? 'icon-a-biaodanguanli2x' : '站内应用'
        // 站内应用
        case 'todoinside':
          return flag ? 'icon-yingyong' : '站内应用'
        // 外部链接
        case 'todooutside':
          return flag ? 'icon-a-qukuailian2x' : '外部链接'
        // 外部链接
        case 'outside':
          return flag ? 'icon-a-qukuailian2x' : '外部链接'
        case 'edit':
          return flag ? 'icon-bianji' : '编辑'
        case 'del':
          return flag ? 'icon-shanchu5' : '删除'
        case 'dataLog':
          return flag ? 'icon-a-chakan2x' : '数据日志'
        case 'blockchain':
          return flag ? 'icon-guanliankongjian' : '区块链'
        case 'qrCode':
          return flag ? 'icon-erweima-' : '写入二维码'
        case 'lookQrCode':
          return flag ? 'icon-erweima-' : '查看二维码'
        case 'dataArchiving':
          return flag ? 'icon-guidang' : '数据归档'
        case 'custom-scene':
          return flag ? 'WSiconfont WSicon-Send' : '自定义场景'
        case 'app-detail':
          return flag ? 'icon-sousuo' : '查看'
        case 'app-print':
          return flag ? 'el-icon-printer' : '打印'
        case 'report-print':
          return flag ? 'el-icon-printer' : '报表打包下载'
        case 'app-report-print':
          return flag ? 'el-icon-printer' : '应用内报表打包下载'
        case 'list-todo':
          return flag ? 'icon-zhongmingming' : '修改'
        case 'continue':
          return flag ? 'icon-faqi' : '继续写'
        case 'again':
          return flag ? 'icon-shuaxin' : '重新写'
        // 默认
        default:
          return flag ? 'icon-dianji' : '默认'
      }
    }
  },
}
</script>

<style scoped lang="scss">
.buttonStyle {
  width: 100%;
  height: 100%;
  --theme-color: #4e86ff;
  $themeColor: var(--theme-color);

  .WSiconfont {
    font-size: 16px !important;
  }

  .btn-four {
    display: flex;
    align-items: center;
    height: 100%;

    &-text {
      color: #4e86ff !important;
      cursor: pointer;
      font-size: 14px;
      margin: 0 5px;
    }
  }

  .btn-five {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 100%;
    border: 1px $themeColor solid;
    box-sizing: border-box;
    width: fit-content;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    color: $themeColor;

    span {
      padding: 0 10px;
    }
  }

  .icon-img {
    width: 20px;
    height: 20px;
  }

  .icon-shanchu5 {
    color: #e47470 !important;
  }

  &:hover {

    .btn-two,
    .btn-three {
      .iconfont {
        color: $themeColor !important;
      }

      span {
        color: $themeColor !important;
      }
    }
  }

  ::v-deep .el-dropdown {
    height: 100%;
  }

  .el-icon-printer {
    font-size: 16px !important;
  }

  .all-todo {
    display: flex;
    height: 100%;
    align-items: center;

    span {
      color: #666666;
      margin: 0 5px;
    }
  }

  ::v-deep .upload-block {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;

    .el-button {
      padding: 5px;
    }
  }

  .btn-one {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 100%;
    background: $themeColor;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    color: #fff;

    span {
      padding: 0 10px;
      line-height: 30px;
      color: #fff;
    }
  }

  .btn-popover {
    height: 30px;
  }

  .btn-four,
  .btn-two,
  .btn-three {
    border-radius: 4px;
  }

  .btn-two,
  .btn-three {
    width: 100%;
    height: 100%;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: $themeColor;
    cursor: pointer;

    .iconfont {
      color: #333;
      font-size: 14px;
      margin-left: 5px;
    }

    span {
      margin: 0 5px;
      color: #666666;
    }
  }
}

::v-deep .popUps {
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);

  .el-dialog__header {
    padding: 18px;
    background-color: #F5F5F5;
    border-radius: 14px 14px 0 0;

    .el-dialog__title {
      font-size: 14px;
      color: #333;
      font-weight: 400;
    }

    .el-dialog__headerbtn {
      top: 8px;
      font-size: 20px;
    }

    .el-dialog__body {
      padding: 5px;
    }
  }
}
</style>
